<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadAppConsumerListDataApi, loadAppConsumerExportDataApi, saveOrUpdateAppConsumerApi } from '@/api/appConsumer'

export default {
  name: 'AppConsumer',
  components: {
    CustomTable,
    TableOperation,
    AddEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_consumer_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['app_consumer_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['app_consumer_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['app_consumer_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['app_consumer_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            certificateNo: '',
            phone: ''
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', filterColumn: 'u.id', label: '编号', width: 80 },
      // { prop: 'wxOpenId', filterColumn: 'wx_open_id', label: '微信OPENID', width: 140 },
      { prop: 'unionId', filterColumn: 'u.union_id', label: '微信统一ID', width: 140 },
      { prop: 'appletTypeStr', filterColumn: 'u.applet_type', filterValue: 'appletType', label: '所属小程序', width: 120, filterArray: [{ label: '渝享荟', value: 1 }, { label: '循香会友', value: 2 }] },
      { prop: 'name', filterColumn: 'u.name', label: '名称', width: 120 },
      { prop: 'phoneStr', filterColumn: 'u.phone', filterValue: 'phone', label: '电话', width: 120 },
      { prop: 'sexStr', filterColumn: 'u.sex', filterValue: 'sex', label: '性别', width: 110, filterArray: [{ label: '男', value: 1 }, { label: '女', value: 2 }] },
      { prop: 'provinceName', filterColumn: 'u.province_name', label: '省区', width: 120 },
      { prop: 'address', filterColumn: 'u.address', label: '详细地址', width: 160 },
      { prop: 'createDateStr', filterColumn: 'u.create_date', label: '注册日期', width: 120 },
      { prop: 'lastLoginTimeStr', filterColumn: 'u.last_login_time', label: '最近登录日期', width: 140 },
      { prop: 'integral', filterColumn: 'u.integral', label: '可用积分', width: 120 },
      { prop: 'integralTotal', filterColumn: 'u.integral_total', label: '累计积分', width: 120 },
      { prop: 'storeName', filterColumn: 'cr.store_name', label: '当前推荐店名', width: 140 },
      { prop: 'ownerName', filterColumn: 'cr.owner_name', label: '推荐店主', width: 120 },
      { prop: 'ownerPhone', filterColumn: 'cr.owner_phone', label: '店主电话', width: 120 },
      { prop: 'sourceTypeStr', filterColumn: 'u.source_type', filterValue: 'sourceType', label: '来源类型', width: 120, filterArray: [{ label: '小程序搜索', value: 0 }, { label: '零售户推荐码', value: 1 }, { label: '消费者分享', value: 2 }] },
      { prop: 'statusStr', filterColumn: 'u.status', filterValue: 'status', label: '状态', width: 120, filterArray: [{ label: '正常', value: 1 }, { label: '停用', value: 2 }] },
      { prop: 'remark', filterColumn: 'u.remark', label: '备注', width: 200 },
      { prop: 'operatorName', filterColumn: 'u.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'u.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '新增用户'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '修改用户'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditViewVisible = !this.dialogAddEditViewVisible
      this.dialogAddEditViewTitle = '查看用户'
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定作废该用户？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateAppConsumerApi({ id: args[0].id, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
